import React, { Component, useState } from 'react';

export default function GridHeaderfilter({populatedata,cleardata}){

    return (
        <>
            {populatedata.map((input, index) => {
                    return (
                        <div className='filter-result bg-white p-1 border rounded-1 me-1 d-flex align-items-center'>
                        <span className='me-2 pe-2 border-end'>{input.name} : {input.value} </span>
                        <a href='#' onClick={()=>cleardata(input)} className='me-1'><i className="ic fa fa-close"></i></a>
                       </div>
                    )
                    })}
        </>
    );
}